import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { usePostHog } from "posthog-js/react";
import { getLogger } from "../utils/logger";

const logger = getLogger("usePostHogIdentify");

/**
 * Identifies authenticated users in PostHog, linking their anonymous
 * pre-login session with their Auth0 identity. Resets on logout so
 * subsequent anonymous activity is not attributed to the previous user.
 */
export const usePostHogIdentify = (): void => {
  const { isAuthenticated, user } = useAuth0();
  const posthog = usePostHog();

  useEffect(() => {
    if (isAuthenticated && user && posthog) {
      posthog.identify(user.sub, {
        email: user.email,
        name: user.name,
      });
      logger.debug("PostHog user identified", { userId: user.sub });
    }
  }, [isAuthenticated, user, posthog]);

  useEffect(() => {
    if (!isAuthenticated && posthog) {
      posthog.reset();
    }
  }, [isAuthenticated, posthog]);
};
